import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
// ValidationBanner not used here; kept import removed to avoid unused import
import { RootState } from '../../store/store'
import { clearSelectedEmployee } from '../../store/slices/admin/manualTimeOffSlice'
import { clearEmployeeScopedData } from '../../store/slices/Requestor/employeeInfoSlice'

const ManualTimeOffBanner = ({
  isSuccessPage,
  className,
}: {
  isSuccessPage?: boolean
  className?: string
}) => {
  const dispatch = useDispatch()
  const selectedEmployee = useSelector(
    (state: RootState) => state.manualTimeOff.selectedEmployee
  )
  const navigate = useNavigate()
  const heading = isSuccessPage
    ? 'Manual Employee Time Off - Successfully submitted request.'
    : 'Manual Employee Time Off'
  // Redux is hydrated from sessionStorage once when the store is created and
  // kept in sync by setSelectedEmployee/clearSelectedEmployee from then on —
  // there is no legitimate point during an active session where it would be
  // empty while sessionStorage still holds a value, so read it directly
  // rather than falling back to a second, independently-read source.
  const effectiveSelected = selectedEmployee

  const handleChangeEmployee = () => {
    // Clear redux + sessionStorage — the logged-in proxy's own profile was
    // never touched, so there is nothing to restore here.
    dispatch(clearSelectedEmployee())
    // Also clear the previously-fetched employee-scoped data itself (not
    // just the selection pointer) so nothing can render stale data for the
    // employee being exited while the next fetch is still in flight.
    dispatch(clearEmployeeScopedData())

    // Navigate to manual timeoff landing
    navigate('/admin/manual-timeoff')
  }

  return (
    <div className={`${className || 'w-full md:w-1/2'} mb-4! mt-4`}>
      <div
        className="ds-banner ds-banner__bg--white ds-banner--icon p-3 mb-0 w-full flex flex-row items-start gap-3"
        data-ds-variant="basic"
        data-ds-version="1"
        data-ds-theme="vessel"
        aria-labelledby="manual-timeoff-banner-title"
        style={{ borderColor: '#003B71' }}
      >
        <div className="ds-banner__icon-img shrink-0">
          <img
            src="/assets/images/informationIcon.svg"
            alt="info icon"
            style={{ width: '42px', height: '42px' }}
          />
        </div>
        <div className="ds-banner__container flex-1">
          <div className="ds-banner__main flex flex-col gap-0">
            <div
              className="ds-banner__main-header--awareness"
              id="manual-timeoff-banner-title"
              style={{ fontWeight: 350, fontSize: '20px' }}
            >
              {heading}
            </div>
            <div className="ds-banner__main-body text-sm leading-tight">
              <p className="p3 -book mt-0!">
                On behalf of {effectiveSelected?.name || 'Employee'} (
                {effectiveSelected?.nuid || 'Unknown'})
              </p>
              <Link
                to="/admin/manual-timeoff"
                onClick={handleChangeEmployee}
                className="text-[#0074AD] inline-block p4 -medium underline"
              >
                Exit Requestor Proxy Manual Mode
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManualTimeOffBanner
